<template>
  <div>
    <div class="footer dark_bg">
      <div class="container">
        <div class="row sections" style="padding-top: 80px; padding-bottom: 10px;">
          <div class="col-md-4" id="footer1">
            <router-link to="/global/terms-of-service">
              <p class="white mplus2p-r spacing2-8 footer_clink" data-translate="_TermsService">
                {{$t('f_side1_title')}}</p>
            </router-link>
          </div>
          <div class="col-md-4" id="footer2">
            <router-link to="/global/privacy-policy">
              <p class="white mplus2p-r spacing2-8 footer_clink" data-translate="_Privacypolicy">
                {{$t('f_side2_title')}}</p>
            </router-link>
          </div>
          <div class="col-md-4" id="footer3">
            <a href="https://e3-pro.com/contact/engineer/">
              <p class="white mplus2p-r spacing2-8 footer_clink" data-translate="_Fcontactus">
                {{$t('f_side3_title')}}</p>
            </a>
          </div>

        </div>
        <div class="row sections" style="padding-top: 40px; padding-bottom: 30px">
          <img src="../../../assets/imgs/logo-white.png" style="margin: auto;">
        </div>
        <div class="row sections text-center" style="padding-top: 0px; padding-bottom: 30px;">
          <p class="white mplus1c spacing1-2" style="margin: auto; font-size: 12px;">
            {{$t('f_copyright')}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style scoped>
</style>
